import { connect } from 'react-redux'

import Actions from '../../Actions/Creators'
import Student from './Component/Student'

import Phi from '../../Phi/Phi'


const mapStateToProps = (state, ownProps) => ({
    organizationId: JSON.parse(Phi.Storage.getItem('organization')) ? JSON.parse(Phi.Storage.getItem('organization'))[0].org_id : null,
    userRole: Phi.User.roles()[0].role_type_id,
    userProfile: Phi.User.profile(),
    studentHeader: state.student.studentHeader,
    studentList: state.student.studentList,
    totalStudent: state.student.totalStudent,
    pdfContent: state.student.pdfContent,
    currentProgram: state.organization.currentProgram,    
    programs: state.organization.programs,
    startNodeMap: state.organization.startNodeMap,
    classes: state.organization.classes,
    dataUpdateFlag: state.organization.dataUpdateFlag
})


const mapDispatchToProps = (dispatch) => ({
    fetchCustomStudentList: (payload, hideLoader) => dispatch(Actions.fetchCustomStudentList(payload, hideLoader)),
    getSchoolClasses: organization_id => dispatch(Actions.getSchoolClasses(organization_id)),
    setLoader: () => dispatch(Actions.setLoader()),
    unsetLoader: () => dispatch(Actions.unsetLoader()),
    addStudentMedicalInfo: (uuid, custom) => dispatch(Actions.addStudentMedicalInfo(uuid, custom)),
    postStudentEpisodeInfo: (studentId, customJson, episodeType) => dispatch(Actions.postStudentEpisodeInfo(studentId, customJson, episodeType))
})


export default connect(mapStateToProps, mapDispatchToProps)(Student)


// WEBPACK FOOTER //
// ./src/Containers/StudentCustomContainer/index.js